import { render, staticRenderFns } from "./FooterScheduling.vue?vue&type=template&id=185b56fc"
import script from "./FooterScheduling.vue?vue&type=script&lang=js"
export * from "./FooterScheduling.vue?vue&type=script&lang=js"
import style0 from "./FooterScheduling.vue?vue&type=style&index=0&id=185b56fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAlert,VIcon,VProgressCircular})
